import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
interface RevenueScenario {
  scenario: number;
  available: number;
  price: string;
  signups: number;
  availabilityPercent: string;
  oneTimeFee: string;
  revenue: string;
  siteShare: string;
  resellerShare: string;
  annualShare: string;
}
interface RevenueScenariosProps {
  scenarios: RevenueScenario[];
}
const RevenueScenarios: React.FC<RevenueScenariosProps> = ({
  scenarios
}) => {
  return <div className="bg-white rounded-lg shadow-md p-6 mb-8 overflow-x-auto">
      <h3 className="text-xl font-semibold mb-4 text-primary-blue">Monthly Income Scenarios</h3>
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-50">
            <TableHead className="text-center">Scenario</TableHead>
            <TableHead className="text-center">Total Available</TableHead>
            <TableHead className="text-center">Monthly Price</TableHead>
            <TableHead className="text-center">Signups</TableHead>
            <TableHead className="text-center">% Used</TableHead>
            <TableHead className="text-center">One Time Fee</TableHead>
            <TableHead className="text-center">Revenue</TableHead>
            <TableHead className="text-center">ReferMe.site Share</TableHead>
            <TableHead className="text-center">Your Share Monthly</TableHead>
            <TableHead className="text-center">Your Annual Share 
(minus fee pd)</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {scenarios.map(scenario => <TableRow key={scenario.scenario} className={scenario.scenario % 2 === 0 ? "bg-gray-50" : ""}>
              <TableCell className="text-center font-medium">{scenario.scenario}</TableCell>
              <TableCell className="text-center">{scenario.available}</TableCell>
              <TableCell className="text-center">{scenario.price}</TableCell>
              <TableCell className="text-center">{scenario.signups}</TableCell>
              <TableCell className="text-center">{scenario.availabilityPercent}</TableCell>
              <TableCell className="text-center">{scenario.oneTimeFee}</TableCell>
              <TableCell className="text-center font-medium">{scenario.revenue}</TableCell>
              <TableCell className="text-center">{scenario.siteShare}</TableCell>
              <TableCell className="text-center font-bold text-green-600">{scenario.resellerShare}</TableCell>
              <TableCell className="text-center font-bold text-green-600">{scenario.annualShare}</TableCell>
            </TableRow>)}
        </TableBody>
      </Table>
      <p className="text-xs text-gray-500 mt-4 italic">* This is a scenario based on industry standards; your actual scenario can differ based on your execution and sales.</p>
    </div>;
};
export default RevenueScenarios;